module.exports = __webpack_public_path__ + "img/light_bottom.904bbb26.png";